module.exports = __webpack_public_path__ + "static/media/10ft_circle-fill2.3ec12565.png";